import { API_BASE_URL } from '../../../../../config';
import { FORM_CODE_FF009 } from './careerUpApplicationTypes';
import type { CareerUpApplicationFormValues } from './careerUpApplicationTypes';

export const DONE_STEP_ID = '__done__';

export type CareerUpApplicationProgressPayload = {
  values: CareerUpApplicationFormValues;
  currentStepId: string | null;
};

export async function fetchCareerUpApplicationProgress(
  email: string,
  invitationId: string
): Promise<CareerUpApplicationProgressPayload | null> {
  if (!API_BASE_URL || !email?.trim() || !invitationId?.trim()) return null;
  const params = new URLSearchParams({
    email: email.trim(),
    invitationId: invitationId.trim(),
    formCode: FORM_CODE_FF009,
  });
  const r = await fetch(`${API_BASE_URL}/api/career-up-application/progress?${params.toString()}`);
  if (!r.ok) return null;
  const data = (await r.json()) as {
    confirmNoCard?: string;
    materialsUnderstood?: string;
    consentDocumentRead?: string;
    agreeApply?: string;
    currentStepId?: string | null;
  };
  const values: CareerUpApplicationFormValues = {};
  if (data.confirmNoCard === 'yes' || data.confirmNoCard === 'no') {
    values.confirmNoCard = data.confirmNoCard;
  }
  if (data.consentDocumentRead === 'true' || data.consentDocumentRead === 'false') {
    values.consentDocumentRead = data.consentDocumentRead;
  } else if (data.materialsUnderstood === 'yes') {
    values.consentDocumentRead = 'true';
  }
  if (data.agreeApply === 'true' || data.agreeApply === 'false') {
    values.agreeApply = data.agreeApply;
  }
  return {
    values,
    currentStepId: data.currentStepId ?? null,
  };
}

export async function upsertCareerUpApplicationProgress(params: {
  email: string;
  invitationId: string;
  values: CareerUpApplicationFormValues;
  currentStepId: string | null;
}): Promise<CareerUpApplicationProgressPayload | null> {
  if (!API_BASE_URL || !params.email?.trim() || !params.invitationId?.trim()) return null;
  try {
    const body: Record<string, string | null> = {
      email: params.email.trim(),
      invitationId: params.invitationId.trim(),
      formCode: FORM_CODE_FF009,
      currentStepId: params.currentStepId,
    };
    if (params.values.confirmNoCard) body.confirmNoCard = params.values.confirmNoCard;
    if (params.values.consentDocumentRead === 'true' || params.values.consentDocumentRead === 'false') {
      body.consentDocumentRead = params.values.consentDocumentRead;
    }
    if (params.values.agreeApply === 'true' || params.values.agreeApply === 'false') {
      body.agreeApply = params.values.agreeApply;
    }

    const r = await fetch(`${API_BASE_URL}/api/career-up-application/progress`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!r.ok) {
      console.warn('Career-up application save failed', r.status);
      return null;
    }
    const data = (await r.json()) as {
      confirmNoCard?: string;
      materialsUnderstood?: string;
      consentDocumentRead?: string;
      agreeApply?: string;
      currentStepId?: string | null;
    };
    const values: CareerUpApplicationFormValues = { ...params.values };
    if (data.confirmNoCard === 'yes' || data.confirmNoCard === 'no') {
      values.confirmNoCard = data.confirmNoCard;
    }
    if (data.consentDocumentRead === 'true' || data.consentDocumentRead === 'false') {
      values.consentDocumentRead = data.consentDocumentRead;
    }
    if (data.agreeApply === 'true' || data.agreeApply === 'false') {
      values.agreeApply = data.agreeApply;
    }
    return {
      values,
      currentStepId: data.currentStepId ?? params.currentStepId,
    };
  } catch (e) {
    console.warn('Career-up application save failed', e);
    return null;
  }
}
